import {Line, Radar} from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  PointElement,
  BarElement,
  CategoryScale,
  RadialLinearScale,
  LineElement,
  Filler
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  PointElement,
  BarElement,
  CategoryScale,
  RadialLinearScale,
  LineElement,
  Filler
)

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.component('RadarChart', Radar)
})
